import {ItemMapObjectFactory} from '../ItemMapObjectFactory';
import {Item} from '../../models/Item';
import {appInjector} from '../appInjector';
import {ToolsService} from '../../services/toolsService/tools.service';
import {AbstractMainPlugin} from '../AbstractMainPlugin';
import {LoggerService} from '../../../logger/logger.service';
import {FigureMainClass} from '../figures/figureMainClass';
import {ObjectConfig} from '../../models/ObjectConfig';
import {ConcreteLayerService} from '../../services/concreteLayer/concrete-layer.service';
import {isDisableDraw, isRemoveSidebar} from '../../../configs/view_only';
import {UiAdapterService} from '../../services/uiAdapterService/ui-adapter.service';
import {ThreeDModel} from '../figures/ThreeDModel';
import {RotateObjectService} from '../../services/rotateService/rotate-object.service';
import {ItemConfig} from '../../models/ItemConfig';
import {CesiumAdapterService} from '../../services/cesiumAdapter21/cesium-adapter.service';
import {Polygon} from '../figures/Polygon';
import {INPUT_COLOR_SETTINGS_NAME, INPUT_OPACITY_SETTINGS_NAME} from '../../interfaces/constants';
import {Polyline} from '../figures/Polyline';
import {RoomLayoutService} from '@src/app/services/roomLayoutService/room-layout-service.service';
import {MultiSelectItemsService} from '../../services/multiSelectItemsService/multi-select-items.service';
import {ItemManagerService} from '../../services/itemManager/item-manager.service';
import {timer} from "rxjs";
import {ObjectsArrayService} from '@src/app/services/objectsArrayService/objects-array.service';

export class MapObjectPlugin extends AbstractMainPlugin {
  static ANCHOR_SUBJECT = 'linked_objects_anchor';

  public object;
  private toolProvider;

  public mapObject : FigureMainClass;
  public ItemMapObjectFactory : ItemMapObjectFactory;

  private currentTool;

  public ms: MultiSelectItemsService;
  private im: ItemManagerService;
  private logger;
  private modalControl;
  private concreteService: ConcreteLayerService;
  private uiAdapterService: UiAdapterService;
  private rotateService: RotateObjectService;
  private cesiumAdapterService: CesiumAdapterService;
  private roomLayoutService: RoomLayoutService;
  private ObjectsArrayService: ObjectsArrayService;
  private isDragInited = false;

  constructor(item: Item) {
    super(item);

    this.ItemMapObjectFactory = appInjector.get(ItemMapObjectFactory);
    this.toolProvider = appInjector.get(ToolsService);
    this.im = appInjector.get(ItemManagerService);
    this.logger = appInjector.get(LoggerService);
    this.ms = appInjector.get(MultiSelectItemsService);
    // this.modalControl = appInjector.get(EsBsModalService);
    this.concreteService = appInjector.get(ConcreteLayerService);
    this.uiAdapterService = appInjector.get(UiAdapterService);
    this.rotateService = appInjector.get(RotateObjectService);
    this.cesiumAdapterService = appInjector.get(CesiumAdapterService);
    this.roomLayoutService = appInjector.get(RoomLayoutService);
    this.ObjectsArrayService = appInjector.get(ObjectsArrayService);

    this.mapObject = this.ItemMapObjectFactory.create(this.item.config.getObjectConfig());
    this.mapObject.itemId = item.getId();

    this.initListeners();

    item.emitter.subscribe((event) => {

      if (event.getEventName() === 'addedToItemManager') {

        if (this.mapObject) {
          const self = this;
          this.mapObject.itemId = item.getId(); // new objects receive ID later
          if (!isDisableDraw) {
            if (
              item.config.getObjectConfig().getToolType() === ObjectConfig.TYPE_POLYGON
              && item.config.getObjectConfig().getPositions().length === 0
            ) {
              return;
            }
            this.mapObject.draw().subscribe((id) => {
              if (this.mapObject.tool.hasOwnProperty('addItemMapping')){
                this.mapObject.tool.addItemMapping(item.getId(), id);
              }
              if (!isRemoveSidebar && id) {
                item.isDrawn = true;
                item.getSubject(Item.AFTER_DRAWN_SUBJECT).next(true);
                this.logger.log(`mapObject Drawed with arguments`);

                self.addDrawnListeners();

                // if (event.isItemWithFixedSize()){
                //   this.mapObject.changeObjectToFixedSize(event.getFixedWidthInputVal() || null)
                // }
              }

            });
          }

        }
      }

    if (!isRemoveSidebar){
      if (event.getEventName() === 'centerOnObject'){
        if (this.mapObject) {
          let param = this.item.config.getToolParam('__object_center_zoom');
          let val = (param && param.hasOwnProperty('value')) ? param.value : null;
          this.mapObject.centerOnObject(val);
        }
      }

      if (event.getEventName() == 'removeObject'){
        if (this.mapObject){
          this.mapObject.removeObject();
        }
      }

      if (event.getEventName() == 'updatedFromServer'){
        let objectConfig = event.getUpdatedConfig();
        let object = objectConfig.objects[0];
        this.mapObject.itemId = objectConfig.getId(); // new objects receive ID later

      }
    }
    })
  }

  private addDrawnListeners(){
    let self = this;
    self.mapObject.clickOnObject.subscribe((object:{entityId, isCtrl})=>{
      self.item.clickOnObject(object);
      // fix for OBJECT_CLICK subscription because object is re-clicked every time placed-item component is initialized
      // todo: move it to an appropriate place
      if (!object.isCtrl) {
        self.uiAdapterService.selectedItem$ = self.item;
      }
    });

    self.item.getSubject(Item.SUBJECT_VISIBILITY).subscribe((visibility)=>{
      self.mapObject.setVisibility(visibility);
    });

    self.item.getSubject(Item.MODEL_TRANSPARENCY).subscribe((val)=>{
      self.mapObject.setTransparency(val);
    });

    self.item.getSubject(Item.MOVE_OBJECT_BY_OFFSET).subscribe((offset)=>{
      self.mapObject.moveByOffsetFromOriginalPosition(offset);
    });

    self.item.getObservable('updateMultiSelectDragPosition').subscribe(()=>{
      self.mapObject.updateObjectPositionByMultiSelect()
    });

    self.item.getSubject(Item.OBJECT_OFFSET_BY).subscribe((offset)=>{
      if (offset && offset != 0){
        self.mapObject.moveBy(offset);
        self.item.getSubject(Item.OBJECT_OFFSET_BY).next(0);
      }
    });

    self.item.getObservable(Item.OBJECT_OFFSET_WITH_DIRECTION).subscribe((event)=>{
      if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.code)){
        self.mapObject.moveWithDirection(event);
      }
    });

    self.item.getObservable(Item.OBJECT_OFFSET_WITH_DIRECTION).subscribe((event)=>{
      if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.code)){
        self.mapObject.moveWithDirection(event);
      }
    });

    self.item.getSubject('rotateObject').subscribe(()=>{
      self.mapObject.onRotateStart();
    });

    self.item.getObservable('executeModelResize').subscribe((config)=>{
      self.mapObject.forceResize(self.item.config.getObjectConfig(), config);
    });
  }

  public hasNumbersOnLine() {
    let inputs = this.item.config.getInputs();
    for (let i in inputs) {
      if (i.indexOf('point_height') >= 0) {
        return true;
      }
    }
    return false;
  }

  private initListeners() {
    if (!isRemoveSidebar) {

      this.mapObject.linkedObjectsAnchor.subscribe((anchorPosition) => {
        this.item.getSubject(MapObjectPlugin.ANCHOR_SUBJECT).next(anchorPosition);
      });

      this.mapObject.dragEnd$.subscribe((object:{oldPosition, object}) => {
        this.roomLayoutService.onDragEnd(this.item);
        this.ObjectsArrayService.onDragEnd(this.item, object);
      });

      this.item.getObservable('highlight_object')
          .subscribe((highlightFlag) => {
            if (!this.item.config.getTool().url_for_dynamic_icon && !this.item.config.getTool().dynamic_image_code) {
              this.mapObject.setObjectHighlight(highlightFlag, this.hasNumbersOnLine());
            }
          });
      //
      // this.item.getObservable('highlight_object').subscribe((highlightFlag)=>{
      //   this.mapObject.setObjectHighlight(highlightFlag)
      // });

      /**
       * degrees - final rotate degrees
       */
      this.item.getSubject(Item.SUBJECT_ROTATE_TO).subscribe((degrees) => {
        if (this.mapObject instanceof ThreeDModel) {
          this.mapObject.rotateTo(degrees);
        }
      });

      this.cesiumAdapterService.onEmptyClick$.subscribe(()=>{
        this.mapObject.stopEdit();
        this.mapObject.setObjectHighlight(false);
      })

      //newVal is amount of degrees to rotate
      this.item.getSubject(Item.SUBJECT_ROTATE_BY).subscribe(({newVal, oldVal}) => {
        // if (this.mapObject instanceof ThreeDModel) {
        //   this.mapObject.rotate(newVal).then(() => {
        //     if(!this.item.config.isCopy){
        //        this.rotateService.objectOutsideRotated(this.item.config.);
        //     }
        //   });
        // } else {
          this.mapObject.rotate(newVal);
        // }
      });

      this.item.config.subject.subscribe((newConfig: ItemConfig) => {
        this.cesiumAdapterService.changeFillAndBorderColor(this.mapObject as any, newConfig);
        const type = newConfig.getObjectConfig().getToolType();

        const itemId = this.item.getId();
        const entityId = this.mapObject.getViewEntityId();
        if (type === ObjectConfig.TYPE_POLYLINE && itemId && entityId && this.mapObject.tool.addItemMapping) {
          this.mapObject.tool.addItemMapping(itemId, entityId);
        }

        if (newConfig.getInputByName(INPUT_COLOR_SETTINGS_NAME)) {
          if (type === ObjectConfig.TYPE_POLYLINE) {
            this.mapObject.tool.setAdditionalObject(
              this.item.getId(),
              'newColor',
              {strokeColor: newConfig.getInputByName(INPUT_COLOR_SETTINGS_NAME).value}
            );
            this.item.config
              .getObjectConfig()
              .setData('strokeColor', newConfig.getInputProp(INPUT_COLOR_SETTINGS_NAME, 'value'));
          }
          if (type === ObjectConfig.TYPE_POLYGON) {
            this.item.config.getObjectConfig().setData('strokeColor', newConfig.getInputProp(INPUT_COLOR_SETTINGS_NAME, 'value'));
            this.item.config.getObjectConfig().fillColor = newConfig.getInputProp(INPUT_COLOR_SETTINGS_NAME, 'value');
          }
        }

        if (newConfig.getInputByName(INPUT_OPACITY_SETTINGS_NAME)) {
          if (type === ObjectConfig.TYPE_POLYLINE || type === ObjectConfig.TYPE_POLYGON) {
            this.mapObject.tool.setAdditionalObject(
              this.item.getId(),
              'newColor',
              {strokeOpacity: newConfig.getInputByName(INPUT_OPACITY_SETTINGS_NAME).value}
            );
            this.item.config.getObjectConfig().setFillOpacity(newConfig.getInputProp(INPUT_OPACITY_SETTINGS_NAME, 'value'));
          }
        }

        timer(500).subscribe(()=>{
          this.cesiumAdapterService.updateScene();
        });
      });

      this.item.dragChanged.subscribe((draggable) => {
        if (draggable && this.isDragInited) {
          this.mapObject.stopEdit();
        }

        if (draggable) {
          this.isDragInited = true;
        }
      });

      // this.item.getSubject(Item.DRAWN_ITEM_ADDED).subscribe((entityId)=>{
      //   this.mapObject.setViewEntityId(entityId);
      //   this.addDrawnListeners();
      // })

      this.mapObject.editStart.subscribe((entityId) => {
        this.currentTool = this.item.config.getTool();
        const isToolEditable = this.currentTool.is_editable;
        if (
          isToolEditable && entityId &&
          (
            this.item.config.getObjectConfig().getToolType() === ObjectConfig.TYPE_POLYLINE
            || this.item.config.getObjectConfig().getToolType() === ObjectConfig.TYPE_POLYGON
            || this.item.config.getObjectConfig().getToolType() === ObjectConfig.TYPE_CIRCLE)
        ) {
          this.item.drag_enabled = false;
          this.mapObject.startEdit(this.hasNumbersOnLine());
        }
      });

      this.mapObject.pointAdded$.subscribe((index)=>{
        this.item.getObservable('pointAdded').next(index);
      })

      this.mapObject.editStop$.subscribe(() => {
        this.item.getObservable('editStop').next(Date.now());
      });

      this.mapObject.dragStart.subscribe((entity) => {
        this.currentTool = this.item.config.getTool();
        const isToolDragged = this.currentTool.is_draggable;
        if (isToolDragged && this.item.drag_enabled) {
          if (entity) {
            // note: [SHR]: difference
            // this.mapObject.startDrag(this.item.config.getCopyParentId);
            this.ms.currentDraggableItemId = this.item.getId();
            this.mapObject.startDrag(Object.keys(this.im.selectedItemList).length > 1);
            if (this.item.config.getObjectConfig().getToolType() === ObjectConfig.TYPE_FIXED_FIGURE) {
              this.rotateService.hideRotateHandler();
            }
            if (this.item.timer) {
              clearTimeout(this.item.timer);
            }
            if (!this.uiAdapterService.globalDragEnabled) {
              this.item.timer = setTimeout(() => {
                // this.modalControl.processDragModal();
                this.item.drag_enabled = false;
                this.item.timer = null;
              }, 30000);
            }
          }
        }
      });

      this.mapObject.hover.subscribe((object: { entityId, position }) => {
        this.mapObject.showHoverText(this.item.config.getTitle() + '\n' + this.item.config.getCreator(), object.position);
      });

      this.concreteService.onConcreteDrawing$.subscribe((val) => {
        this.mapObject.setGrayScale(val);
      });

      this.concreteService.parentItemId.subscribe((val) => {
        if (this.item.getId() === val) {
          this.mapObject.highlightForConcreteDrawing();
        } else {
          this.mapObject.removeHighlightForConcreteDrawing();
        }
      });
    }
  }
}
